<script>
import { mapGetters } from "vuex";

import Tabla from "./Resultados/Tabla.vue";
import Panels from "./Resultados/Panels.vue";
import Thumbnails from "./Resultados/Thumbnails.vue";

import InfiniteLoading from "vue-infinite-loading";

import SinResultados from "./SinResultados.vue";
import PlaceholderResultado from "./Placeholder/Resultado.vue";
import PlaceholderResultados from "./Placeholder/Resultados.vue";

export default {
  components: {
    Tabla,
    Panels,
    Thumbnails,
    SinResultados,
    InfiniteLoading,
    PlaceholderResultado,
    PlaceholderResultados
  },
  computed: {
    ...mapGetters([
      "isMaster",
      "isPreloader",
      "isResultados",
      "isResultadosView",
      "getPagina",
      "isPaginas",
      "getPaginas",
      "getResultados"
    ])
  },
  methods: {
    paginar($state) {
      if (this.getPaginas > this.getPagina) {
        let pagina = this.getPagina;
        pagina++;
        this.$store.commit("setPagina", pagina);
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    clear() {
      this.$emit("clear");
    }
  }
};
</script>

<template>
  <div class="resultados">
    <placeholder-resultados v-if="!isMaster &&  isPreloader" :cantidad="5"></placeholder-resultados>

    <template v-if="isResultados">
      <tabla v-if="isResultadosView(3)"></tabla>
      <Panels v-if="isResultadosView(1)"></Panels>
      <thumbnails v-if="isResultadosView(2)"></thumbnails>

      <div v-if="isPaginas">
        <infinite-loading @infinite="paginar">
          <template slot="spinner">
            <placeholder-resultado></placeholder-resultado>
          </template>
          <template slot="no-more">Todos los circuitos estan cargados</template>
          <template slot="no-results">Sin resultados</template>
        </infinite-loading>
      </div>
    </template>

    <sin-resultados
      v-if="(isMaster && !isResultados) || (!isMaster && !isPreloader)"
      @clear="clear"
    ></sin-resultados>
  </div>
</template>

<style lang="scss" scoped>
.resultados {
  margin-bottom: 15px;
  .no-more {
    color: #b0b0b0;
    font-size: 18px;
    font-weight: 100;
    border-top: 1px dashed #ddd;
    padding-top: 15px;
    margin-bottom: 15px;
  }
}

@media (min-width: 992px) {
  .resultados {
    min-height: 100vh;
  }
}
</style>